module.exports = __webpack_public_path__ + "img/laravel-fullstack-app6.654676c6.png";